// Module
var code = "You should return one last time to your busy thoroughfare, it's ok if it's no longer busy.. press ‘I’m there’ when you are. ";
// Exports
module.exports = code;